import React, { Component } from 'react'
import Page from '../components/Page'
import TrialForm from '../partials/TrialForm'

export default class TrialProductionCustomLabel extends Component {
  render () {
    return (
      <Page size='full'>
        <TrialForm type="productionCustomLabel" />
      </Page>
    )
  }
}
